<template>
    <div id="home" v-if="show" :class="{'height2': home_active == 2}">
        <div class="role_loading" v-if="role_loading">
            <van-loading type="spinner" size="3rem" />
        </div>
        <!-- <van-button v-if="!this.$store.state.gameId" round color="var(--theme)" class="choose_game_btn" @click="chooseGame">请先选择游戏</van-button> -->
        <div class="home-top" :class="{'height2': home_active == 2}">
            <div class="ht_bg">
                <div class="ht1">
                    <div class="ht1_game" @click="openChooseGame">
                        <van-image :src="ac_game_icon"/>
                        <div class="game_name">
                            {{ gameName == "" ? "游戏列表" : gameName }}
                        </div>
                        <img class="exchange_icon" src="../../assets/version_1.3.6/exchange.png" alt="">
                    </div>
                    <div class="ht1_add" @click="toggleAddDeskGuide">
                        <van-icon name="plus" color="var(--theme)"/>
                        添加桌面
                    </div>
                </div>
                <div class="ht2">
                    <p :class="{'active': home_active == 1}" v-if="prop_trade == 1" @click="$store.commit('changeHome',1);keywords = '';">道具市场</p>
                    <p :class="{'active': home_active == 2}" v-if="role_trade == 1" @click="$store.commit('changeHome',2);keywords = '';">角色市场</p>
                </div>
            </div>
            <div class="ht3">
                <div class="ht3_search">
                    <van-search show-action left-icon="" v-model="keywords" placeholder="搜索" @search="onSearchKey">
                        <template #action><div class="action" @click="onSearchKey">搜索</div></template>
                    </van-search>
                </div>
            </div>
            <div class="ht4" v-if="home_active == 1">
                <a href="javascript:;" class="select_serve" @click="openRoleList" v-if="role_name == '' || role_name == 'undefined'">
                    点击筛选角色所在区服范围
                </a>
                <a href="javascript:;" class="select_serve choosed" v-else>
                    <p><span>{{ role_name }}</span><span>{{ home_server_name }}</span></p>
                    <p class="cancel_role" @click="cancel_role"><van-icon name="cross" color="var(--theme)"/></p>
                </a>
            </div>
            <div class="ht5" :class="{'open': showPropBox || showServerBox}" v-if="home_active == 1">
                <a href="javascript:;" :class="{active: showPropBox}" @click.prevent="toggleDrop('prop')">
                    <span class="name">{{ propName || '全部道具' }}</span>
                    <span class="sort_icon">
                        <i class="triangle down2" :class="{'active': showPropBox}"></i>
                    </span>
                </a>
                <a href="javascript:;" @click.prevent="toggleSort('num')">
                    <span class="name">数量</span>
                    <span class="sort_icon">
                        <i :class="['triangle','up',{active: order_key == 'num' && order_type == 'asc'}]"></i>
                        <i :class="['triangle','down',{active: order_key == 'num' && order_type == 'desc'}]"></i>
                    </span>
                </a>
                <a href="javascript:;" :class="{active: showServerBox}" @click.prevent="toggleDrop('server')">
                    <span class="name">{{ $store.state.home_server_name || '区服' }}</span>
                    <span class="sort_icon">
                        <i class="triangle down2" :class="{'active': showServerBox}"></i>
                    </span>
                </a>
                <a href="javascript:;" @click.prevent="toggleSort('price')">
                    <span class="name">单价</span>
                    <span class="sort_icon">
                        <i :class="['triangle','up',{active: order_key == 'price' && order_type == 'asc'}]"></i>
                        <i :class="['triangle','down',{active: order_key == 'price' && order_type == 'desc'}]"></i>
                    </span>
                </a>
            </div>

            <div class="ht6" :class="{'open': showChannelBox || showRoleServerBox || showNewBox}" v-if="home_active == 2">
                <a href="javascript:;" :class="{active: showChannelBox}" @click.prevent="toggleRoleDrop('channel')">
                    <span class="name">{{ channelName || '全部渠道' }}</span>
                    <span class="sort_icon">
                        <i class="triangle down2" :class="{'active': showChannelBox}"></i>
                    </span>
                </a>
                <a href="javascript:;" :class="{active: showRoleServerBox}" @click.prevent="toggleRoleDrop('server')">
                    <span class="name">{{ ac_server_name || '全部区服' }}</span>
                    <span class="sort_icon">
                        <i class="triangle down2" :class="{'active': showRoleServerBox}"></i>
                    </span>
                </a>
                <a href="javascript:;" :class="{active: showNewBox}" @click.prevent="toggleRoleDrop('new')">
                    <span class="name">{{ roleOrderText }}</span>
                    <span class="sort_icon">
                        <i class="triangle down2" :class="{'active': showNewBox}"></i>
                    </span>
                </a>
            </div>
        </div>

        <div v-if="showAddDeskGuide" class="adddesk_mask" @click="closeAddDeskGuide">
            <div class="adddesk_content" @click.stop="closeAddDeskGuide">
                <img class="adddesk_img" :src="addDeskGuideImg" alt="">
            </div>
        </div>

        <div v-if="showPropBox || showServerBox || showChannelBox || showRoleServerBox || showNewBox" class="home-mask" :class="{'height2': home_active == 2}" @click="closeDrop"></div>
        <div v-if="showPropBox || showServerBox || showChannelBox || showRoleServerBox || showNewBox" class="home-drop" :class="{'height2': home_active == 2}">
            <div v-if="showPropBox" class="drop_box props_box">
                <div class="props_left scrollbar">
                    <List :list="propList" :index="propTypeId" :immediate="true" @confirmed="handlePropConfirm" />
                </div>
                <div class="props_right scrollbar">
                    <div :class="{'category_type':true,'active':propTypeId == ''}" @click="changePropType('')">
                        全部
                    </div>
                    <div v-for="(item,i) in categoryList" :key="i" :class="{'category_type':true,'active':propTypeId == item.category_id}" @click="changePropType(item.category_id)">
                        {{ item.category_name }}
                    </div>
                </div>
            </div>
            <div v-if="showServerBox" class="drop_box server_box">
                <van-search show-action v-model="serverKey" placeholder="请输入您的区服" @search="onSearch">
                    <template #action><div class="action" @click="onSearch">搜索</div></template>
                </van-search>
                <div class="scroll_area">
                    <notice-scroll :url="'game/app-server-list'" :params="{app_id: currentAppId, keyword: keyServer}" :method="'get'" :text="''">
                        <template slot-scope="scope">
                            <div class="server_list">
                                <div :class="['server_item',{active: home_server_id == item.server_id}]" v-for="(item,i) in scope.data" :key="i" @click="chooseServer(item.server_id,item.server_name)">{{ item.server_name }}</div>
                            </div>
                        </template>
                    </notice-scroll>
                </div>
            </div>
            <div v-if="showChannelBox" class="drop_box channel_box">
                <div class="scroll_area" style="height: 100%;">
                    <div class="server_list">
                        <div :class="['server_item',{active: platform_id == ''}]" @click="chooseChannel('')">全部渠道</div>
                        <div :class="['server_item',{active: platform_id == channelItemId(item)}]" v-for="(item,i) in channelList" :key="i" @click="chooseChannel(item)">{{ channelItemName(item) }}</div>
                    </div>
                    <div class="close_area" @click="closeDrop('channel')"></div>
                </div>
            </div>
            <div v-if="showRoleServerBox" class="drop_box server_box">
                <van-search show-action v-model="serverKey" placeholder="请输入您的区服" @search="onSearch">
                    <template #action><div class="action" @click="onSearch">搜索</div></template>
                </van-search>
                <div class="scroll_area">
                    <notice-scroll :url="'game/app-server-list'" :params="{app_id: currentAppId, keyword: keyServer}" :method="'get'" :text="''">
                        <template slot-scope="scope">
                            <div class="server_list">
                                <div :class="['server_item',{active: ac_server_id == ''}]" @click="chooseRoleServer('','')">全部区服</div>
                                <div :class="['server_item',{active: ac_server_id == item.server_id}]" v-for="(item,i) in scope.data" :key="i" @click="chooseRoleServer(item.server_id,item.server_name)">{{ item.server_name }}</div>
                            </div>
                        </template>
                    </notice-scroll>
                </div>
            </div>
            <div v-if="showNewBox" class="drop_box new_box">
                <div class="scroll_area" style="height: 100%;">
                    <div class="server_list">
                        <div :class="['server_item',{active: order_key == 'id'}]" @click="chooseRoleOrder('new')">最新上架</div>
                        <div :class="['server_item',{active: order_key == 'price' && order_type == 'asc'}]" @click="chooseRoleOrder('asc')">最低价格</div>
                        <div :class="['server_item',{active: order_key == 'price' && order_type == 'desc'}]" @click="chooseRoleOrder('desc')">最高价格</div>
                    </div>
                    <div class="close_area" @click="closeDrop('new')"></div>
                </div>
            </div>
        </div>

        <div v-if="home_active == 1">
            <home-scroll ref="goodsScroll" url="goods/index-v3" :params="params" :refresh-key="currentAppId + '-' + listReloadKey" :method="'get'">
                <template slot-scope="scope">
                    <div class="goods_list">
                        <home-dj v-for="(row,i) in scope.data" :row="row" :key="i" />
                    </div>
                </template>
            </home-scroll>
        </div>
        <div v-if="home_active == 2">
            <home-scroll2 ref="roleScroll" :url="'goods-role/index'" :params="params2" :refresh-key="currentAppId + '-' + listReloadKey" method="get">
                <template slot-scope="scope">
                    <div class="account_item" v-for="(item,i) in scope.data" :key="i" @click="gotoDetail(item.id)">
                        <div class="left">
                            <van-image class="first_pic" :src="item.first_pic" v-if="item.first_pic"></van-image>
                            <van-image :src="ac_game_icon" v-else></van-image>
                            <div class="goods-desc" v-if="item.desc">{{ item.desc }}</div>
                        </div>
                        <div class="right">
                            <div class="want" v-if="item.want">
                                <span>{{ item.want }}</span>人想要
                            </div>
                            <div class="bottom">
                                <div class="role_info" v-if="roleInfoList(item.role_attr).length">
                                    <span v-for="(ri, idx) in roleInfoList(item.role_attr)" :key="idx" class="item">
                                        {{ ri.name }}:{{ ri.value }}
                                    </span>
                                </div>
                            </div>
                            <p class="tit">
                                <i>卖家说 :</i>
                                <span> {{ item.goods_name }}</span>
                            </p>
                            <div class="top">
                                <div class="qf_price">
                                    <p class="qf">
                                        <span>{{ item.server_name }}</span>
                                        <!-- <span class="sys" v-if="item.system_name">{{ item.system_name }}</span> -->
                                        <span>{{ item.channel_name }}</span>
                                    </p>
                                </div>
                            </div>
                            <p class="price"><i>&yen;</i>{{ item.price }}</p>
                        </div>
                    </div>
                </template>
            </home-scroll2>
        </div>

        <!-- 极速售卖 -->
        <img ref="jssmBtn" class="jssm animate__animated animate__tada animate__repeat-2" :style="jssmStyle" src="../../assets/version_1.3.0/market/jssm.png" alt="" draggable="false" @dragstart.prevent @click="onJssmClick" @touchstart="onJssmStart" @mousedown="onJssmStart">
    </div>
</template>
<script>
    export default {
        props: ['showJc'],
        data() {
            return {
                role_loading: false,
                showAddDeskGuide: false,
                addDeskScrollTop: 0,
                listReloadKey: 0,
                lastAppId: '',
                show: false,
                server_id: '',//项目id
                keywords: '',//搜索关键词
                keyword: '',
                order_key: '', 
                order_type: '',               
                showPropBox: false,
                showServerBox: false,
                showChannelBox: false,
                showRoleServerBox: false,
                showNewBox: false,
                serverKey: '',
                keyServer: '',
                categoryList: [],
                propTypeId: '',
                propList: [],
                propName: '',
                channelList: [],
                platform_id: '',//渠道id
                channelName: '',
                roleList: [],
                jssmPosLeft: null,
                jssmPosTop: null,
                jssmDragging: false,
                jssmDragStartX: 0,
                jssmDragStartY: 0,
                jssmDragOriginLeft: 0,
                jssmDragOriginTop: 0,
                jssmDragMoved: false,
                jssmClickBlocked: false,
                jssmDragWidth: 0,
                jssmDragHeight: 0,
            }
        },
        activated() {
            if (this.$route.name == 'home' && !this.$route.query.id && this.$store.state.gameId) {
                this.$router.replace({
                    name: 'home',
                    query: Object.assign({}, this.$route.query, {
                        id: this.$store.state.gameId
                    })
                })
            }
            if (this.lastAppId && this.currentAppId && this.lastAppId != this.currentAppId) {
                this.forceReloadLists()
            }
        },
        deactivated() {
            this.closeAddDeskGuide()
        },
        beforeDestroy() {
            this.closeAddDeskGuide()
            this.onJssmEnd()
        },
        created() {
            if(this.$route.query&&this.$route.query.id) {
                this.$Ajax('game/app-list').then(rs => {
                    if (rs.code == 200) {
                        rs.data.forEach(item => {
                            if(item.id == this.$route.query.id) {
                                this.chooseGame(item.app_name,item.icon,item.id,item.prop_trade,item.role_trade)
                            }
                        });
                    }
                })
            }
        },
        mounted() {
            this.lastAppId = this.currentAppId
            var that = this
            setTimeout(() => {
                that.show = true
            }, 500)
            this.$nextTick(() => {
                setTimeout(() => {
                    this.loadJssmPos()
                }, 0)
            })
        },
        computed: {
            jssmStyle() {
                if (this.jssmPosLeft === null || this.jssmPosTop === null) return {}
                return {
                    left: this.jssmPosLeft + 'px',
                    top: this.jssmPosTop + 'px',
                    bottom: 'auto',
                    transform: 'none'
                }
            },
            isWechatBrowser() {
                return /micromessenger/i.test(navigator.userAgent)
            },
            addDeskGuideImg() {
                if (this.isWechatBrowser) {
                    return require('../../assets/version_1.3.6/openinbower.png')
                }
                return require('../../assets/version_1.3.6/setup.png')
            },
            currentAppId() {
                if (this.$route && this.$route.name === 'home') {
                    return this.$route.query.id || this.$store.state.gameId || ''
                }
                return this.$store.state.gameId || ''
            },
            params() {
                const params = {
                    app_id: this.currentAppId,
                    category_id: this.$store.state.category_id,
                    server_id: this.$store.state.home_server_id,
                    keyword: this.keyword,
                    order_key: this.order_key,
                    order_type: this.order_type,
                }
                Object.keys(params).forEach(key => {
                    if (params[key] === '' || params[key] === null || params[key] === undefined) {
                        delete params[key]
                    }
                })
                return params
            },
            params2() {
                const params = {
                    app_id: this.currentAppId,
                    server_id: this.$store.state.ac_server_id,
                    goods_name: this.keyword,
                    order_key: this.order_key ? this.order_key : 'id',
                    order_type: this.order_type ? this.order_type : 'desc',
                    platform_id: this.platform_id,
                }
                Object.keys(params).forEach(key => {
                    if (params[key] === '' || params[key] === null || params[key] === undefined) {
                        delete params[key]
                    }
                })
                return params
            },
            home_server_id() {
                return this.$store.state.home_server_id
            },
            home_server_name() {
                return this.$store.state.home_server_name
            },
            home_active() {
                return this.$store.state.home_active
            },
            ac_game_icon() {
                return this.$store.state.gameIcon
            },
            gameName() {
                return this.$store.state.gameName
            },
            gameIcon() {
                return this.$store.state.gameIcon;
            },
            isLogin() {
                return this.$store.getters.isLogin;
            },
            prop_trade() {
                return this.$store.state.prop_trade
            },
            role_trade() {
                return this.$store.state.role_trade
            },
            category_type() {
                return this.$store.state.category_type
            },
            category_id() {
                return this.$store.state.category_id
            },
            isLogin() {
                return this.$store.getters.isLogin;
            },
            role_name() {
                return this.$store.state.role_name || ''
            },
            ac_server_id() {
                return this.$store.state.ac_server_id
            },
            ac_server_name() {
                return this.$store.state.ac_server_name
            },
            roleOrderText() {
                if (this.order_key == 'price' && this.order_type == 'asc') return '最低价格'
                if (this.order_key == 'price' && this.order_type == 'desc') return '最高价格'
                return '最新上架'
            }
        },
        methods: {
            roleInfoList(item) {
                const raw = item
                if (!raw) return []
                let list = raw
                if (typeof raw === 'string') {
                    try {
                        list = JSON.parse(raw)
                    } catch (e) {
                        return []
                    }
                }
                if (!Array.isArray(list) && list && typeof list === 'object') {
                    list = Object.keys(list)
                        .sort((a, b) => Number(a) - Number(b))
                        .map(key => list[key])
                }
                if (!Array.isArray(list)) return []
                return list.filter(ri => ri && ri.name && ri.value !== undefined && ri.value !== null && ri.value !== '').slice(0, 3)
            },
            loadJssmPos() {
                try {
                    const el = this.$refs.jssmBtn
                    if (!el || !el.getBoundingClientRect) return

                    const rect = el.getBoundingClientRect()
                    const w = rect.width || this.jssmDragWidth || 0
                    const h = rect.height || this.jssmDragHeight || 0
                    const maxLeftNow = Math.max(0, window.innerWidth - w)
                    const maxTopNow = Math.max(0, window.innerHeight - h)

                    const raw = window.localStorage.getItem('jssm_pos') || ''
                    if (!raw) return
                    const pos = JSON.parse(raw)
                    const left = pos && Number(pos.left)
                    const top = pos && Number(pos.top)
                    const leftP = pos && Number(pos.leftP)
                    const topP = pos && Number(pos.topP)
                    const vw = pos && Number(pos.vw)
                    const vh = pos && Number(pos.vh)
                    const oldW = pos && Number(pos.w)
                    const oldH = pos && Number(pos.h)

                    let useLeftP = Number.isFinite(leftP) ? leftP : null
                    let useTopP = Number.isFinite(topP) ? topP : null

                    if (useLeftP === null && Number.isFinite(vw) && Number.isFinite(left)) {
                        const maxLeftOld = Math.max(0, vw - (Number.isFinite(oldW) ? oldW : w))
                        if (maxLeftOld > 0) useLeftP = left / maxLeftOld
                    }
                    if (useTopP === null && Number.isFinite(vh) && Number.isFinite(top)) {
                        const maxTopOld = Math.max(0, vh - (Number.isFinite(oldH) ? oldH : h))
                        if (maxTopOld > 0) useTopP = top / maxTopOld
                    }

                    let nextLeft = null
                    let nextTop = null

                    if (useLeftP !== null && Number.isFinite(useLeftP)) {
                        nextLeft = Math.min(Math.max(0, useLeftP), 1) * maxLeftNow
                    } else if (Number.isFinite(left)) {
                        nextLeft = Math.min(Math.max(0, left), maxLeftNow)
                    }

                    if (useTopP !== null && Number.isFinite(useTopP)) {
                        nextTop = Math.min(Math.max(0, useTopP), 1) * maxTopNow
                    } else if (Number.isFinite(top)) {
                        nextTop = Math.min(Math.max(0, top), maxTopNow)
                    }

                    if (!Number.isFinite(nextLeft) || !Number.isFinite(nextTop)) return
                    this.jssmPosLeft = nextLeft
                    this.jssmPosTop = nextTop
                } catch (e) {}
            },
            saveJssmPos() {
                try {
                    if (this.jssmPosLeft === null || this.jssmPosTop === null) return
                    const vw = window.innerWidth
                    const vh = window.innerHeight
                    const w = this.jssmDragWidth || (this.$refs.jssmBtn && this.$refs.jssmBtn.getBoundingClientRect ? this.$refs.jssmBtn.getBoundingClientRect().width : 0) || 0
                    const h = this.jssmDragHeight || (this.$refs.jssmBtn && this.$refs.jssmBtn.getBoundingClientRect ? this.$refs.jssmBtn.getBoundingClientRect().height : 0) || 0
                    const maxLeft = Math.max(0, vw - w)
                    const maxTop = Math.max(0, vh - h)
                    const leftP = maxLeft > 0 ? (this.jssmPosLeft / maxLeft) : 0
                    const topP = maxTop > 0 ? (this.jssmPosTop / maxTop) : 0
                    window.localStorage.setItem('jssm_pos', JSON.stringify({
                        left: this.jssmPosLeft,
                        top: this.jssmPosTop,
                        leftP,
                        topP,
                        vw,
                        vh,
                        w,
                        h
                    }))
                } catch (e) {}
            },
            onJssmClick() {
                if (this.jssmClickBlocked) return
                this.jssm()
            },
            onJssmStart(e) {
                const el = this.$refs.jssmBtn
                if (!el) return

                if (e && e.type === 'mousedown') {
                    if (e.button !== 0) return
                    if (e.cancelable) e.preventDefault()
                }

                const point = e && e.touches && e.touches[0] ? e.touches[0] : e
                if (!point) return

                const rect = el.getBoundingClientRect()
                this.jssmDragWidth = rect.width
                this.jssmDragHeight = rect.height

                if (this.jssmPosLeft === null || this.jssmPosTop === null) {
                    this.jssmPosLeft = rect.left
                    this.jssmPosTop = rect.top
                }

                this.jssmDragging = true
                this.jssmDragMoved = false
                this.jssmDragStartX = point.clientX
                this.jssmDragStartY = point.clientY
                this.jssmDragOriginLeft = this.jssmPosLeft
                this.jssmDragOriginTop = this.jssmPosTop

                window.addEventListener('mousemove', this.onJssmMove, { passive: false })
                window.addEventListener('mouseup', this.onJssmEnd, { passive: true })
                window.addEventListener('touchmove', this.onJssmMove, { passive: false })
                window.addEventListener('touchend', this.onJssmEnd, { passive: true })
                window.addEventListener('touchcancel', this.onJssmEnd, { passive: true })
            },
            onJssmMove(e) {
                if (!this.jssmDragging) return
                const el = this.$refs.jssmBtn
                if (!el) return

                const point = e && e.touches && e.touches[0] ? e.touches[0] : e
                if (!point) return

                const dx = point.clientX - this.jssmDragStartX
                const dy = point.clientY - this.jssmDragStartY
                if (Math.abs(dx) + Math.abs(dy) > 6) this.jssmDragMoved = true

                const maxLeft = Math.max(0, window.innerWidth - this.jssmDragWidth)
                const maxTop = Math.max(0, window.innerHeight - this.jssmDragHeight)

                const nextLeft = Math.min(Math.max(0, this.jssmDragOriginLeft + dx), maxLeft)
                const nextTop = Math.min(Math.max(0, this.jssmDragOriginTop + dy), maxTop)

                this.jssmPosLeft = nextLeft
                this.jssmPosTop = nextTop

                if (e && e.cancelable) e.preventDefault()
            },
            onJssmEnd() {
                if (!this.jssmDragging) return
                this.jssmDragging = false

                window.removeEventListener('mousemove', this.onJssmMove)
                window.removeEventListener('mouseup', this.onJssmEnd)
                window.removeEventListener('touchmove', this.onJssmMove)
                window.removeEventListener('touchend', this.onJssmEnd)
                window.removeEventListener('touchcancel', this.onJssmEnd)

                const movedPx = Math.abs(this.jssmPosLeft - this.jssmDragOriginLeft) + Math.abs(this.jssmPosTop - this.jssmDragOriginTop)
                if (this.jssmDragMoved || movedPx > 1) {
                    this.saveJssmPos()
                    this.jssmClickBlocked = true
                    setTimeout(() => {
                        this.jssmClickBlocked = false
                    }, 300)
                }
            },
            forceReloadLists() {
                if (!this.currentAppId) return
                this.closeDrop()
                this.resetHomeFilter()
                this.listReloadKey++
                this.lastAppId = this.currentAppId
            },
            toggleAddDeskGuide() {
                if (this.showAddDeskGuide) {
                    this.closeAddDeskGuide()
                    return
                }
                this.openAddDeskGuide()
            },
            openAddDeskGuide() {
                this.showAddDeskGuide = true
                this.lockBodyScroll()
            },
            closeAddDeskGuide() {
                if (!this.showAddDeskGuide) return
                this.showAddDeskGuide = false
                this.unlockBodyScroll()
            },
            onAddDeskTouchMove(e) {
                if (!this.showAddDeskGuide) return
                const content = e.target && e.target.closest ? e.target.closest('.adddesk_content') : null
                if (content) return
                e.preventDefault()
            },
            lockBodyScroll() {
                this.addDeskScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
                document.body.style.position = 'fixed'
                document.body.style.top = -this.addDeskScrollTop + 'px'
                document.body.style.left = '0'
                document.body.style.right = '0'
                document.body.style.width = '100%'
                document.body.style.overflow = 'hidden'
                document.addEventListener('touchmove', this.onAddDeskTouchMove, { passive: false })
            },
            unlockBodyScroll() {
                document.removeEventListener('touchmove', this.onAddDeskTouchMove, { passive: false })
                document.body.style.position = ''
                document.body.style.top = ''
                document.body.style.left = ''
                document.body.style.right = ''
                document.body.style.width = ''
                document.body.style.overflow = ''
                window.scrollTo(0, this.addDeskScrollTop || 0)
            },
            openRoleList() {
                if(!this.isLogin) {
                    this.$filterPop({
                        type: "login",
                        direction: 'up',
                        onSuccess: () => {
                            this.openRolePop()
                        }
                    })
                }else {
                    this.openRolePop()
                }
            },
            openRolePop() {
                this.$Ajax('user-info/accounts', {
                    app_id: this.currentAppId,
                }).then(rs => {
                    if (rs.code == 200) {
                        this.roleList = rs.data || []
                        const openRoleServer = (val) => {
                            var that = this
                            this.$filterPop({
                                type: 'roleserver',
                                direction: 'up',
                                selection: {
                                    role3: true
                                },
                                onFunc: (data) => {
                                    if (data && data.action == 'back') {
                                        setTimeout(() => {
                                            openRole3()
                                        }, 0)
                                    }
                                },
                                onSuccess: (data) => {
                                    this.role_loading = true
                                    this.$Ajax('goods-role/cp-rolelist', {
                                        app_id: this.currentAppId,
                                        account_id: val.role_id,
                                        server_id: data.server_id,
                                        child_user_id: val.child_user_id,
                                    }, 'post', {
                                        timeout: 35000
                                    }).then(rs => {
                                        if (rs.code == 200) {
                                            this.role_loading = false
                                            if (rs.data.length > 0) {
                                                this.$RModal.accounts({
                                                    noheader: true,
                                                    selection: {
                                                        app_id: that.currentAppId,
                                                        account_id: val.role_id,
                                                        icon: that.gameIcon,
                                                        roles: rs.data,
                                                        index: 0,
                                                        account: val.game_account,
                                                        child_user_id: val.child_user_id,
                                                    },
                                                    onSuccess: (info) => {
                                                        that.chooseRole(info.role_id, info.role_name, info.server_id, info.server_name)
                                                    }
                                                })
                                            } else {
                                                this.$RModal.norole({ noheader: true })
                                            }
                                        } else if (rs.code == 406) {
                                            that.role_loading = false
                                            this.$RModal.norole({
                                                noheader: true,
                                                selection: {
                                                    message: rs.msg
                                                }
                                            })
                                        } else {
                                            that.role_loading = false
                                        }
                                    })
                                }
                            })
                        }
                        const openRole3 = () => {
                            this.$filterPop({
                                type: 'role3',
                                direction: 'up',
                                selection: {
                                    roleList: this.roleList
                                },
                                onSuccess: (val) => {
                                    openRoleServer(val)
                                }
                            })
                        }
                        openRole3()
                    }
                })
            },
            chooseRole(role_id, role_name, server_id, server_name, account_id) {
                this.$store.commit('bindHomeServer', { server_id, server_name })
                this.$store.commit('setBindrole', {
                    role_id,
                    role_name,
                })
                this.$store.commit('bindServer', {
                    server_id,
                    server_name
                })
                if(account_id) {
                    this.$store.commit('bindAcid', account_id)
                }
            },
            cancel_role() {
                this.$store.commit('bindHomeServer', {})
                this.$store.commit('setBindrole', {})
                this.$store.commit('bindServer', {})
                this.$store.commit('bindAcid', '')
            },
            onSearchKey() {
                this.keyword = this.keywords
            },
            openChooseGame() {
                this.$filterPop({
                    type: "game3",
                    direction: 'up',
                });
            },
            toggleDrop(type) {
                const app_id = this.currentAppId
                if (!app_id) return
                this.showChannelBox = false
                this.showRoleServerBox = false
                this.showNewBox = false
                if (type == 'prop') {
                    this.showServerBox = false
                    this.showPropBox = !this.showPropBox
                    if (this.showPropBox) this.getCategory(app_id)
                    return
                }
                this.showPropBox = false
                this.showServerBox = !this.showServerBox
            },
            toggleRoleDrop(type) {
                const app_id = this.currentAppId
                if (!app_id) return
                this.showPropBox = false
                this.showServerBox = false
                if (type == 'channel') {
                    this.showRoleServerBox = false
                    this.showNewBox = false
                    this.showChannelBox = !this.showChannelBox
                    if (this.showChannelBox) this.getChannels()
                    return
                }
                if (type == 'server') {
                    this.showChannelBox = false
                    this.showNewBox = false
                    this.showRoleServerBox = !this.showRoleServerBox
                    return
                }
                this.showChannelBox = false
                this.showRoleServerBox = false
                this.showNewBox = !this.showNewBox
            },
            closeDrop() {
                this.showPropBox = false
                this.showServerBox = false
                this.showChannelBox = false
                this.showRoleServerBox = false
                this.showNewBox = false
            },
            getCategory(app_id) {
                var that = this
                this.$Ajax('game/app-category-list', { app_id }).then(rs => {
                    if (rs.code == 200) {
                        this.categoryList = rs.data || []
                        if (this.categoryList.length == 0) return
                        if (this.category_type == '') {
                            this.propTypeId = ''
                            this.propList = []
                        } else {
                            this.propTypeId = this.category_type
                            this.categoryList.forEach((item, i) => {
                                if (item.category_id == that.propTypeId) {
                                    that.propList = that.categoryList[i].children || []
                                }
                            })
                        }
                        this.syncPropName()
                    }
                })
            },
            changePropType(category_id) {
                var that = this
                this.propTypeId = category_id
                if (category_id == '') {
                    this.propList = []
                    return
                }
                this.categoryList.forEach((item, i) => {
                    if (item.category_id == category_id) {
                        that.propList = that.categoryList[i].children || []
                    }
                })
            },
            handlePropConfirm() {
                this.syncPropName()
                this.closeDrop()
            },
            syncPropName() {
                this.propName = ''
                this.categoryList.forEach(item => {
                    if (item.category_id == this.category_type && this.category_id == this.category_type) {
                        this.propName = item.category_name
                    }
                    ;(item.children || []).forEach(child => {
                        if (child.category_id == this.category_id) {
                            this.propName = child.category_name
                        }
                    })
                })
            },
            onSearch() {
                this.keyServer = this.serverKey
            },
            chooseServer(server_id, server_name) {
                this.$store.commit('bindHomeServer', { server_id, server_name })
                this.closeDrop()
            },
            channelItemId(item) {
                return item.id
            },
            channelItemName(item) {
                return item.name
            },
            getChannels() {
                this.$Ajax('game/channels', { app_id: this.currentAppId },'get').then(rs => {
                    if (rs.code == 200) {
                        this.channelList = rs.data || []
                    }
                })
            },
            chooseChannel(item) {
                if (item == '') {
                    this.platform_id = ''
                    this.channelName = '全部渠道'
                    this.closeDrop()
                    return
                }
                this.platform_id = item.id
                this.channelName = item ? (this.channelItemName(item) || '') : ''
                this.closeDrop()
            },
            chooseRoleServer(server_id, server_name) {
                this.$store.commit('setAcServer', {
                    ac_server_id: server_id,
                    ac_server_name: server_name
                })
                this.closeDrop()
            },
            chooseRoleOrder(type) {
                if (type == 'new') {
                    this.order_key = 'id'
                    this.order_type = 'desc'
                    this.closeDrop()
                    return
                }
                this.order_key = 'price'
                this.order_type = type
                this.closeDrop()
            },
            resetHomeFilter() {
                this.showPropBox = false
                this.showServerBox = false
                this.showChannelBox = false
                this.showRoleServerBox = false
                this.showNewBox = false
                this.serverKey = ''
                this.keyServer = ''
                this.categoryList = []
                this.propTypeId = ''
                this.propList = []
                this.propName = ''
                this.channelList = []
                this.platform_id = ''
                this.channelName = ''
                this.keywords = ''
                this.keyword = ''
                this.order_key = ''
                this.order_type = ''
                this.cancel_role()
            },
            toggleSort(type) {
                this.closeDrop()
                this.order_key = type
                this.order_type = this.order_type == 'asc' ? 'desc' : 'asc'
            },
            gotoDetail(goods_id) {
                this.$router.push({
                    name: 'acc.goods',
                    query: {
                        goods_id
                    }
                })
            },
            chooseGame(name, icon, id,prop_trade,role_trade) {
                this.$store.commit('resetServer')
                this.$store.commit('resetHomeServer')
                this.$store.commit('setGameInfo', {
                    name,
                    icon,
                    id
                })

                this.$store.commit('setCt','')
                this.$store.commit('setCi','')
                this.$store.commit('setCt2','')
                this.$store.commit('setCi2','')
                //道具市场 角色市场判断
                this.$store.commit('setHome',{prop_trade,role_trade})
                if(prop_trade == 0) {
                  this.$store.commit('changeHome',2)
                }else {
                  this.$store.commit('changeHome',1)
                }
                if(prop_trade == 0 && role_trade == 0) {
                    this.$router.replace({name: 'home',query: {id}})
                }else if(this.$route.query.home_active == 1 && prop_trade == 1) {
                    this.$router.replace({
                        name: 'home',
                        query: {
                            id,
                            home_active: 1
                        }
                    })
                }else if(this.$route.query.home_active == 1 && prop_trade == 0 && role_trade == 1) {
                    this.$router.replace({
                        name: 'home',
                        query: {
                            id,
                            home_active: 2
                        }
                    })
                }else if(this.$route.query.home_active == 2 && role_trade == 1) {
                    this.$router.replace({
                        name: 'home',
                        query: {
                            id,
                            home_active: 2
                        }
                    })
                }else if(this.$route.query.home_active == 2 && prop_trade == 1 && role_trade == 0) {
                    this.$router.replace({
                        name: 'home',
                        query: {
                            id,
                            home_active: 1
                        }
                    })
                }
                //角色市场 筛选全部重置
                this.$store.commit('resetAccPx')    
            },
            jssm() {
                if (!this.isLogin) {
                    this.$filterPop({
                        type: 'login',
                        direction: 'up',
                        onSuccess: () => {
                            this.$router.push({name: 'sell'})
                        }
                    })
                }else {
                    this.$router.push({name: 'sell'})
                }
            }
        },
        watch: {
            '$store.state.gameId'(newVal, oldVal) {
                if (newVal && newVal != oldVal) {
                    if (this.$route.name == 'home' && !this.$route.query.id) {
                        this.$router.replace({
                            name: 'home',
                            query: Object.assign({}, this.$route.query, {
                                id: newVal
                            })
                        })
                    }
                    this.forceReloadLists()
                }
            },
            '$route.query.id'(newVal, oldVal) {
                if (this.$route.name != 'home') return
                if (!newVal || newVal == oldVal) return
                if (newVal == this.$store.state.gameId) return
                this.$Ajax('game/app-list').then(rs => {
                    if (rs.code != 200) return
                    const game = (rs.data || []).find(item => item.id == newVal)
                    if (!game) return
                    this.chooseGame(game.app_name, game.icon, game.id, game.prop_trade, game.role_trade)
                })
            },
            home_active: {
                immediate: true,
                handler(e) {
                    if(e == 2) {
                        this.order_key = 'id'
                        this.order_type = 'desc'
                    }else {
                        this.order_key = ''
                        this.order_type = ''
                    }
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .account_item {
        background-color: #fff;
        border-radius: 1rem;
        margin: 0 1rem 1rem;
        cursor: pointer;
        overflow: hidden;
        // transition: all ease .25s;
        // &:hover {
        //     transform: scale(1.025);
        // }
        .left {
            background-color: #000;
            height: 15rem;
            position: relative;
            .goods-desc {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 3rem;
                line-height: 3rem;
                background-color: rgba(10, 0, 0, 0.56);
                padding: 0 1rem;
                color: #fff;
                font-size: 1.4rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .van-image {
            width: 100%;
            height: 100%;
            overflow: hidden;
            position: relative;
            /deep/.van-image__img {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                width: auto;
                height: 100%;
            }
        }
        .right {
            padding: .5rem .5rem 1.2rem;
            position: relative;
            .bottom {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: .5rem;
            }
            .tit {
                width: 80%;
                font-size: 1.4rem;
                color: #000;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: 700;
                margin-bottom: .5rem;
                i {
                    display: inline-block;
                    font-size: 1.4rem;
                    padding: .3rem .5rem;
                    background-color: rgba(246, 111, 48, .81);
                    transform: scale(0.9);
                    transform-origin: 0 center;
                    color: #fff;
                    border-radius: 0.4rem;
                    font-weight: 700;
                }
            }
            .top {
                width: 75%;
                word-break: break-word;
            }
            .qf_price {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;

                .qf {
                    font-size: 1.3rem;
                    color: #999;
                    flex: 1;
                    word-break: break-all;
                    span {
                        display: inline-block;
                        padding: 0 .6rem;
                        border-radius: .2rem;
                        margin-right: .1rem;
                        &:nth-child(1) {
                            padding-left: 0;
                        }
                    }
                }

                .price {
                    margin-left: 1rem;
                    font-size: 1.6rem;
                    font-weight: 700;
                    color: var(--theme);

                    i {
                        font-size: 1.2rem;
                        font-weight: 400;
                        margin-right: 0.2rem;
                    }
                }
            }
            .want {
                position: absolute;
                right:  1rem;
                top: 1.2rem;
                font-size: 1.2rem;
                color: #999;
                display: flex;
                align-items: flex-end;
            }
            .price {
                position: absolute;
                right: 1rem;
                bottom: 1.2rem;
                font-size: 2rem;
                color: #EF4D3D;
                font-weight: 700;
                i {
                    font-size: 1.4rem;
                    font-weight: normal;
                    margin-right: .2rem;
                }
            }
        }
    }

    .choose_game_btn {
        padding: 0 1.2rem;
        height: 3.2rem;
        font-size: 1.2rem;
        display: block;
        margin: 2rem auto;
    }
    .role_info {
        display: flex;
        align-items: center;
        color: var(--theme);
        border: 1px solid var(--theme);
        padding: .4rem .8rem;
        border-radius: .4rem;
        font-size: 1.2rem;
        .item {
            margin-right: .8rem;
                &:last-child {
                margin-right: 0;
            }
        }
        
    }

    .jssm {
        z-index: 1000;
        width: 6rem;
        height: auto;
        position: fixed;
        bottom: 10rem;
        left: calc(50% + 10rem);
        transform: translateX(-50%);
        cursor: pointer;
        touch-action: none;
        user-select: none;
        -webkit-user-drag: none;
    }

    #home {
        padding-top: 25rem;
        &.height2 {
            padding-top: 20.5rem;
        }
    }
    .home-top {
        position: fixed;
        top: 0;
        width: 100%;
        max-width: 525px;
        height: 25rem;
        background-color: #fff;
        z-index: 100;
        &.height2 {
            height: 20.5rem;
        }
        .ht_bg {
            background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
        }
        .ht1 {
            height: 6.8rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 1rem;
            .ht1_game {
                display: flex;
                align-items: center;
                width: 19.2rem;
                height: 2.9rem;
                background-color: rgba(255, 255, 255, .79);
                border-radius: 4rem;
                padding-left: 2.5rem;
                margin-left: 1.4rem;
                position: relative;
                cursor: pointer;
                &:hover {
                    background-color: #fff;
                }
                .van-image {
                    width: 3.6rem;
                    height: 3.6rem;
                    border-radius: .4rem;
                    overflow: hidden;
                    position: absolute;
                    top: -0.4rem;
                    left: -1.4rem;
                }
                .game_name {
                    color: #000;
                    font-size: 1.4rem;
                    width: 13rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .exchange_icon {
                    width: 1.4rem;
                    position: absolute;
                    right: 1rem;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            .ht1_add {
                width: 9.9rem;
                height: 2.9rem;
                border-radius: 5rem;
                background-color: rgba(255, 255, 255, .79);
                display: flex;
                align-items: center;
                justify-content: center;
                color: var(--theme);
                font-size: 1.4rem;
                cursor: pointer;
                &:hover {
                    background-color: #fff;
                }
                .van-icon {
                    font-size: 1.6rem;
                    margin-right: .1rem;
                    margin-top: .1rem;
                }
            }
        }
        .ht2 {
            height: 4.1rem;
            background-color: #FF854B;
            border-radius: 1rem 1rem 0px 0px;
            display: flex;
            p {
                height: 100%;
                line-height: 4.1rem;
                width: 10.6rem;
                text-align: center;
                font-size: 1.6rem;
                color: #fbfbfb;
                cursor: pointer;
                &.active {
                    font-weight: 700;
                }
            }
        }
        .ht3 {
            padding: 1.5rem 1rem .5rem;
            .ht3_search {
                width: 100%;
                height: 4rem;
                background-color: #f5f5f5;
                border-radius: 8rem;
                display: flex;
                align-items: center;                
                .van-search {
                    flex: 1;
                    background-color: transparent;
                    border: none;
                    outline: none;
                    padding: 0 1rem;
                    font-size: 1.4rem;
                    color: #000;
                    .van-cell {
                        font-size: 1.4rem;
                    }
                    &::placeholder {
                        color: #999;
                    }
                }
                .van-search__action {
                    width: 6.9rem;
                    height: 3.1rem;
                    line-height: 3.1rem;
                    text-align: center;
                    background-color: var(--theme);
                    color: #fff;
                    border-radius: 8rem;
                    font-size: 1.4rem;
                    &:active {
                        opacity: 0.9;

                    }
                }
            }
        }
        .ht4 {
            padding: 1rem 1rem 0;
            .select_serve {
                display: block;
                width: 100%;
                height: 4rem;
                line-height: 4rem;
                background-color: #FFEFE4;
                border-radius: .8rem;
                font-size: 1.4rem;
                color: var(--theme);
                text-align: center;
                &:hover {
                    color: #fc9768;
                }
                &.choosed {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-left: 2.3rem;
                    padding-right: 1rem;
                    span {
                        color: #606060;
                        font-size: 1.4rem;
                        &:nth-child(1) {
                            font-weight: 700;
                            margin-right: 1rem;
                        }
                    }
                    .cancel_role {
                        width: 1.5rem;
                        height: 1.5rem;
                        background-color: rgba(246, 111, 48, .21);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        .van-icon {
                            font-size: 1rem;
                        }
                    }
                }
            }
        }
        .ht5,
        .ht6 {
            padding: 1rem 1rem;
            display: flex;
            &.open {
                background-color: #fff;
            }
            a {
                flex: 1;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #333;
                font-size: 1.4rem;
                overflow: hidden;
                .name {

                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                &.active { 
                    color: var(--theme); 
                }
                .sort_icon { 
                    margin-left: .4rem; 
                    display: flex; 
                    flex-direction: column; 
                    justify-content: center; 
                    gap: .2rem; 
                }
                .triangle { 
                    width: 0; 
                    height: 0; 
                    border-left: .4rem solid transparent; 
                    border-right: .4rem solid transparent; 
                    border-radius: .2rem; 
                }
                .up { 
                    border-bottom: .4rem solid #555; 
                    border-top: unset;
                }
                .down { 
                    border-top: .4rem solid #555; 
                }
                .down2 { 
                    border-left: .5rem solid transparent; 
                    border-right: .5rem solid transparent; 
                    border-top: .6rem solid currentColor; 
                    border-radius: .3rem; 
                    &.active {
                        border-bottom: .6rem solid var(--theme); 
                        border-top: unset;
                    }
                }
                .triangle.active { 
                    border-bottom-color: var(--theme); 
                    border-top-color: var(--theme); 
                }
            }
        }
        .ht6 {
            padding-top: 0.8rem;
            justify-content: space-between;
            a {
                flex: unset;
                width: 10rem;
            }
        }
    }
    .home-mask {
        position: fixed;
        top: 0;
        left: 50%;
        width: 100%;
        max-width: 525px;
        height: 22rem;
        transform: translateX(-50%);
        background: rgba(0,0,0,.4);
        z-index: 101;
        &.height2 {
            height: 17rem;
        }
    }
    .home-drop {
            position: fixed;
            top: 25rem;
            left: 50%;
            width: 100%;
            max-width: 525px;
            height: calc(var(--vh,1vh)*100 - 25rem);
            transform: translateX(-50%);
            z-index: 102;
            &.height2 {
                top: 20.5rem;
                height: calc(var(--vh,1vh)*100 - 20.5rem);
            }
            .drop_box { 
                height: 100%; 
                background: #fff; 
                overflow: hidden; 
                &.channel_box,
                &.new_box {
                    background-color: rgba(0, 0, 0, 0.4);
                    .scroll_area {
                        display: flex;
                        flex-direction: column;
                    }
                    .server_list {
                        background-color: #fff;
                        padding: 0 0 1rem;
                        flex-direction: column;
                        .server_item {
                            width: 100%;
                            height: 3.2rem;
                            line-height: 3.2rem;
                            background-color: unset;
                            text-align: left;
                            padding: 0;
                            margin: 0;
                            padding-left: 3.1rem;
                            cursor: pointer;
                        }
                    }
                    .close_area {
                        flex: 1;
                    }
                }
            }
            .props_box { display: flex; flex-direction: row-reverse;}
            .props_left { flex: 1; overflow-y: auto; padding-top: .8rem;padding-left: 1.9rem; color: var(--base); }
            .props_right { width: 9.4rem; overflow-y: auto; background-color: #f6f6f6;border-top-right-radius: 1rem;border-bottom-right-radius: 1rem; }
            .category_type { padding: .8rem 0; text-align: center; cursor: pointer;font-size: 1.4rem;color: #606060; }
            .category_type.active { color: var(--theme); background-color: #fff; }
            .prop_item,

            .prop_item.active,
            .server_item.active { 
                background: var(--theme); 
                color: #fff; 
            }
            .server_box { 
                padding-top: 1.5rem; 
                .van-search {
                    padding: 0 2rem 0 1rem;
                    .van-cell {
                        font-size: 1.4rem;
                        display: flex;
                        align-items: center;
                        /deep/.van-field__left-icon {
                            .van-icon-search {
                                font-size: 1.6rem;
                                color: #b0b0b0;
                            }
                        }
                    }
                    .van-search__content {
                        border-radius: 10rem;
                        height: 3.4rem;
                    }
                }
            }
            .scroll_area { height: calc(100% - 5rem); overflow-y: auto; }
            .server_list { 
                padding: 1rem; 
                display: flex; 
                flex-wrap: wrap; 
                .server_item { 
                    width: 48%;
                    margin-right: 4%;
                    padding: 0 1rem; 
                    height: 3rem; 
                    line-height: 3rem; 
                    margin-bottom: 1.3rem; 
                    border-radius: 10rem; 
                    background: #f2f2f2; 
                    text-align: center; 
                    font-size: 1.4rem; 
                    color: #555; 
                    white-space: nowrap; 
                    overflow: hidden; 
                    text-overflow: ellipsis; 
                    &:nth-child(2n) {
                        margin-right: 0;
                    }
                    &:hover {
                        background: #FFEFE4; 
                        color: var(--theme); 
                    }
                    &.active {
                        background: #FFEFE4; 
                        color: var(--theme); 
                    }
                }
            }
            .action { color: var(--theme); font-size: 1.4rem; }
        }
    .adddesk_mask {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 525px;
        height: 100vh;
        background: rgba(0, 0, 0, .65);
        z-index: 30000;
        overflow: hidden;
    }
    .adddesk_content {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
    }
    .adddesk_img {
        display: block;
        width: 100%;
        height: auto;
    }
    .goods_list {
        padding: 0 1rem
    }
</style>
